import { render, staticRenderFns } from "./VideoRecorder.vue?vue&type=template&id=f53fb93a&scoped=true&"
import script from "./VideoRecorder.vue?vue&type=script&lang=js&"
export * from "./VideoRecorder.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecorder.vue?vue&type=style&index=0&id=f53fb93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53fb93a",
  null
  
)

export default component.exports